import { ConfigModel } from '@/models/config';

export { FEATURE_FLAGS, USER_FLAGS } from '@/models/config';

const config = new ConfigModel(window._flatfairContext);
window._config = config;
export default config;
